import { AsyncStatus, PlatformApplication } from 'lib-shared-legacy-types';
import { useCallback, useEffect, useState } from 'react';

import { getPlatformApplications } from './api';

export type PlatformApplicationsReturn = {
  items: PlatformApplication[];
  refreshItems: () => void;
  asyncStatus: AsyncStatus;
};

export function usePlatformApplications(
  messengerId?: string,
): PlatformApplicationsReturn {
  const [platformApplications, setPlatformApplications] = useState<
    PlatformApplication[]
  >([]);
  const [asyncStatus, setAsyncStatus] = useState<AsyncStatus>('succeeded');

  const getPlatformApplicationsRequest = useCallback(async () => {
    if (!messengerId) {
      return;
    }

    setAsyncStatus('loading');

    try {
      const { data } = await getPlatformApplications(messengerId);
      setPlatformApplications(data.platformApplications);
      setAsyncStatus('succeeded');
    } catch {
      setAsyncStatus('failed');
    }
  }, [messengerId]);

  useEffect(() => {
    getPlatformApplicationsRequest();
  }, [getPlatformApplicationsRequest]);

  return {
    items: platformApplications,
    asyncStatus,
    refreshItems: getPlatformApplicationsRequest,
  };
}
